import { useQuery } from '@tanstack/react-query';

import { OrderDirection } from '#features/api/types';
import { getBlogPosts } from '#features/blog/model/blog';

export const useBlogTags = () => {
  const { data } = useQuery({
    queryKey: ['blogPosts', 'allTags'],
    queryFn: () =>
      getBlogPosts({
        offset: 0,
        limit: 100,
        orders: [{ direction: OrderDirection.DESC, field: 'date' }],
      }),
    select: (data) => {
      const tagCounts = new Map<string, number>();
      for (const post of data.records) {
        if (post.tags) {
          for (const tag of post.tags.split(',')) {
            const trimmed = tag.trim();
            if (trimmed) {
              tagCounts.set(trimmed, (tagCounts.get(trimmed) || 0) + 1);
            }
          }
        }
      }
      // Sort by frequency, then alphabetically
      return [...tagCounts.entries()]
        .toSorted((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
        .map(([tag]) => tag);
    },
  });

  return data ?? [];
};
